<template>
  <div ref="scroll-content" class="main_container main_container_fixed">
    <template v-if="loading">
      <loader :msg="'GETTING_OFFER_WAIT'" :msg2="'WAIT'" />
    </template>
    <template v-else>
      <div class="sub_container w-row">
        <div class="column-10 w-col w-col-3"></div>
        <div class="column-2 w-col w-col-6">
          <img src="@/assets/images/Group-11560.svg" loading="lazy" width="126" alt="" class="image-4" />
          <h1 class="heading-3" v-html="$t(helpTexts[getMotorOfferStep])"></h1>
        </div>
        <div class="column-16 w-col w-col-3">
            <button type="button" v-if="getMotorOfferStep === 3 || getMotorOfferStep === 4" class="button_circle_medium w-button" @click="promoCode">{{$t('PROMO_CODE')}}</button>
          </div>
      </div>
      <template v-if="getMotorOfferStep === 0 || getMotorOfferStep === 1 || getMotorOfferStep === 2">
        <div class="sub_container w-form">
          <offer-vehicle-search v-if="getMotorOfferStep === 0 && data.CS_VEHICLE" :data="data" @search-vehicle="searchVehicle" @not-registered=notRegistered />
          <offer-vehicle-details v-if="getMotorOfferStep === 1 && data.CS_VEHICLE" :data="data" @next="checkValidationUpdateStep" @change-manufacturer="changeManufacturer" />
          <offer-driver-details v-if="getMotorOfferStep === 2 && data.CS_DRIVERS" :data="data" @motor-calculation="getMotorCalculation" />
        </div>
        <div class="sub_container footer w-row">
          <div class="column_footer_b w-clearfix w-col w-col-6">
            <img src="@/assets/images/Group-10068.svg" loading="lazy" alt="" class="image-5" />
            <p class="bold_label">{{$t('FIELDS_REQUIRED_EXCEPT')}}</p>
          </div>
          <div class="column_footer_b w-clearfix w-col w-col-6">
            <img src="@/assets/images/Group-11600.svg" loading="lazy" alt="" class="image-6" />
            <p class="bold_label">
              {{$t('FIELDS_CHECKED_TOM_CALCULATED_COST')}}
            </p>
          </div>
        </div>
      </template>
      <offer-packages v-if="getMotorOfferStep === 3 && data.CT_PACKAGES" :data="data" @select-package="selectPackage" @next="checkValidationUpdateStep" />
      <offer-packages-analytic v-if="getMotorOfferStep === 4 && data.CT_PACKAGES" :data="data" @select-package="selectPackage" @select-cover="selectCover" @next="checkValidationUpdateStep" @send-email="sendEmailValidation" />
      <offer-payment v-if="getMotorOfferStep === 5 && data.CS_VEHICLE" :data="data" @select-step="selectStep" @payment="payment" />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import OfferVehicleSearch from '@/views/Motor/Offer/OfferComponents/OfferVehicleSearch.vue';
import Vue from 'vue';
import { validateRules } from '@/shared/api/dataServices';
import Loader from '@/components/Loader.vue';

export default {
  /* metaInfo() {
    const title = this.$t('VEHICLE_INSURANCE');
    return {
      title,
      meta: [
        {
          property: 'og:title',
          content: title,
          vmid: 'og:title'
        },
        {
          property: 'twitter:title',
          content: title,
          vmid: 'twitter:title'
        }
      ]
    };
  }, */
  data() {
    return {
      loading: false,
      helpTexts: {
        0: 'FULLFILL_VEHICLE_DATA',
        1: 'FULLFILL_VEHICLE_DATA_START',
        2: 'FULLFILL_DRIVER_DETAILS',
        3: 'PACKAGE_DETAILS',
        4: 'PACKAGE_ANALYTIC',
        5: 'PAYMENT_DETAILS'
      }
    };
  },
  components: {
    OfferVehicleSearch,
    Loader,
    OfferVehicleDetails: () => import('@/views/Motor/Offer/OfferComponents/OfferVehicleDetails.vue'),
    OfferDriverDetails: () => import('@/views/Motor/Offer/OfferComponents/OfferDriverDetails.vue'),
    OfferPackages: () => import('@/views/Motor/Offer/OfferComponents/OfferPackages.vue'),
    OfferPackagesAnalytic: () => import('@/views/Motor/Offer/OfferComponents/OfferPackagesAnalytic.vue'),
    OfferPayment: () => import('@/views/Motor/Offer/OfferComponents/OfferPayment.vue')
  },
  computed: {
    ...mapGetters('motor', ['getMotorOfferStep']),
    ...mapState({
      data: (state) => state.motor.motor,
    }),

  },
  created() {
    if (!this.data.CS_VEHICLE) {
      this.$router.push({ path: '/motor' });
    }
  },
  methods: {
    ...mapActions('motor', ['searchVehicleAction', 'motorGetModelAction', 'motorGetMakeAction', 'motorUpdateDataAction', 'setMotorOfferStepAction', 'motorCalculationAction', 'motorSelectPackageAction', 'motorPackageCalculation', 'motorUpdateValueAction']),
    checkValidationUpdateStep() {
      console.log(this.data);
      const validation = this.$h.checkValidationRules(this.data.ET_CHECK_POINTS, this.data);
      console.log(validation);
      if (validation.REFERRAL) {
        validateRules(validation.RULES);
        this.$router.push({ name: 'ErrorPage' });
        return;
      }
      this.updateStep();
    },
    updateStep() {
      this.motorUpdateDataAction(this.data);
      this.setMotorOfferStepAction(this.getMotorOfferStep + 1);
      Vue.nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    selectStep(step) {
      this.setMotorOfferStepAction(step);
    },
    async searchVehicle(data) {
      await this.searchVehicleAction(data);
      this.checkValidationUpdateStep();
      // this.$emit('next');
    },
    async notRegistered() {
      await this.motorGetMakeAction(this.data.CS_VEHICLE);
      this.checkValidationUpdateStep();
    },
    async changeManufacturer() {
      await this.motorGetModelAction(this.data.CS_VEHICLE);
    },
    async getMotorCalculation() {
      this.loading = true;
      const {
        CS_VEHICLE, CS_DRIVERS, CS_POLICY_HOLDER, CS_PROMO_CODE, CS_POLICY,
      } = this.data;
      await this.motorCalculationAction({
        CS_VEHICLE,
        CS_DRIVERS,
        CS_POLICY_HOLDER,
        CS_PROMO_CODE,
        CS_POLICY
      });
      this.checkValidationUpdateStep();
      this.loading = false;
    },
    selectPackage(item) {
      this.motorSelectPackageAction(item);
      this.checkValidationUpdateStep();
    },
    async selectCover(data) {
      const {
        CS_VEHICLE, CS_DRIVERS, CS_POLICY_HOLDER, CS_PROMO_CODE,
        CS_POLICY
      } = this.data;
      await this.motorPackageCalculation({
        CS_VEHICLE,
        CS_DRIVERS,
        CS_POLICY_HOLDER,
        CS_PROMO_CODE,
        CS_POLICY,
        ...data
      });
    },
    promoCode() {
      this.$router.push({ name: 'PromoCodeForm', params: { product: 'motor' } });
    },
    sendEmailValidation() {
      this.motorUpdateValueAction({ path: 'send_via_email', value: true });
      this.motorUpdateValueAction({ path: 'motor.IS_USER_ADD_FIELDS.SEND_VIA_MAIL', value: true });
      this.$router.push({ name: 'EmailValidationForm', params: { product: 'motor' } });
    },
    payment() {
      this.motorUpdateValueAction({ path: 'send_via_email', value: false });
      this.motorUpdateValueAction({ path: 'motor.IS_USER_ADD_FIELDS.SEND_VIA_MAIL', value: false });
      this.motorUpdateValueAction({ path: 'motor.CS_POLICY.START_DATE', value: '' });
      this.motorUpdateValueAction({ path: 'motor.CS_POLICY_HOLDER.BIRTH_DATE', value: '' });
      this.$router.push({ name: 'EmailValidationForm', params: { product: 'motor' } });
    }
  }
};
</script>
